import * as constants from './constants'

export const hasReceivedConfiguration = (state = false, { type }) =>
    type === constants.CONFIGURATION_RECEIVED ? true : state

export const configurationPending = (state = false, action) => {
    switch (action.type) {
        case constants.REQUEST_CONFIGURATION:
            return true
        case constants.CONFIGURATION_RECEIVED:
            return false
        default:
            return state
    }
}

export function wordpress(state = {}, action) {
    const { type } = action

    switch (type) {
        case constants.CONFIGURATION_RECEIVED:
            return {
                ...state,
                ...action.configuration.entities,
                airports: action.configuration.result.airports,
                themeSettings: action.configuration.result.themeSettings,
            }

        default:
            return state
    }
}

export function subscription(state = {}, action) {
    const { type } = action

    switch (type) {
        case constants.REQUEST_SUBSCRIBE_NEWS:
            return {
                ...state,
                subscribed: false,
                subscribeMessage: undefined,
                email: action.email,
            }

        case constants.SUBSCRIBE_NEWS_SUCCEEDED:
            return {
                ...state,
                subscribed: true,
                subscribeMessage: action.message,
            }

        default:
            return state
    }
}
